namespace $.$$ {

	export class $shm_hitalama_map_statistics extends $.$shm_hitalama_map_statistics {

		sub() {
			// Guard before constructing rows or reading CRDT channels, including on close.
			return this.active() ? super.sub() : []
		}

		format( count: number ) { return count.toLocaleString( 'ru-RU' ) }

		loading_time_text() {
			const process = this.$.$shm_hitalama_map_loading.latest( this.map().link().str )?.root.process
			if( !process ) return 'Загрузка карты: —'
			const status = process.data().status
			if( status === 'running' ) return 'Карта загружается…'
			if( status === 'failed' ) return 'Ошибка загрузки карты'
			if( status !== 'done' ) return 'Загрузка карты прервана'
			const ms = process.duration()
			const duration = ms < 1000 ? `${ Math.round( ms ) } мс`
				: `${ ( ms / 1000 ).toLocaleString( 'ru-RU', { maximumFractionDigits: 2 } ) } с`
			return `Загрузка карты: ${ duration }`
		}

		widgets_text() {
			const count = this.widgets().length
			const mod = count % 100
			const word = mod >= 11 && mod <= 14 ? 'виджетов'
				: count % 10 === 1 ? 'виджет' : count % 10 >= 2 && count % 10 <= 4 ? 'виджета' : 'виджетов'
			return `${ this.format( count ) } ${ word }`
		}

		map_units_text() {
			return `${ this.format( this.units( this.map().land() ) ) } юнитов · карта`
		}

		widget_units_text() {
			return `${ this.format( this.widget_units() ) } юнитов · данные виджетов`
		}

		lands_text() {
			return `Лендов в памяти: ${ this.format( 1 + this.loaded_widget_lands().length ) }`
		}

		/** Native Faces counts data/rights units, not transport Pass/Seal envelopes.
		 * Read dictionary sizes only: no values, sand decoding, signing or sync.
		 * Subscribe to the nested native dictionaries so replacements/removals update us too.
		 */
		@ $mol_mem_key
		units( land: $giper_baza_land ) {
			let count = land._gift.size
			for( const peers of land._sand.values() ) count += this.head_units( peers )
			return count
		}

		@ $mol_mem_key
		head_units( peers: $mol_wire_dict< string, $mol_wire_dict< string, $giper_baza_unit_sand > > ) {
			let count = 0
			for( const sands of peers.values() ) count += sands.size
			return count
		}

		@ $mol_mem
		widget_units() {
			return this.loaded_widget_lands().reduce( ( count, land )=> count + this.units( land ), 0 )
		}

		@ $mol_mem
		loaded_widget_lands() {
			const root = this.map().land().link()
			const owners = new Set( [ root.lord().str ] )
			const direct = new Set< string >()
			for( const widget of this.widgets() ) direct.add( widget.link().land().str )
			const lands: $giper_baza_land[] = []
			const glob = this.$.$giper_baza_glob
			for( const id of glob.lands_touched ) {
				if( id === root.str ) continue
				const link = new this.$.$giper_baza_link( id )
				// Map-owned areas include the loaded manifests and entity shards.
				// Standalone widget lands are included explicitly, never all areas of
				// another map merely because one of its widgets is referenced here.
				if( !direct.has( id ) && !( link.str !== link.lord().str && owners.has( link.lord().str ) ) ) continue
				// Admit only existing lands, then retain their memo channels while
				// statistics are mounted. A probe alone does not subscribe and lets
				// the global cache reap lands when another UI consumer disappears.
				const land = this.$.$mol_wire_probe( ()=> glob.Land( link ) )
				if( land ) lands.push( glob.Land( link ) )
			}
			return lands
		}
	}
}
